
export default {
  layout: 'blank',
  props: {
    error: {
      type: Object,
      default: () => ({ statusCode: 500, message: 'Unknown error' }),
    },
  },
  head() {
    return {
      title: this.title,
    }
  },
  computed: {
    title() {
      return this.error.statusCode === 404
        ? 'Page Not Found'
        : 'Oops! Something went wrong'
    },
  },
  mounted() {
    if (this.error?.statusCode === 404) {
      setTimeout(() => {
        this.$router.replace('/')
      }, 3000) // Optional: redirect after 3s
    }
  },
  methods: {
    goHome() {
      this.$router.replace('/')
    },
  },
}
